/**
 * Legal entity — the LLC that operates this brand. Per-project (each site has its
 * own LLC, even within the same vertical). Written by `site-factory new` from
 * the answers you provided; edit in place if anything changes.
 *
 * Required for footer fine print, legal pages (terms / privacy / refund), and
 * payment-acquirer compliance (merchant DBA on receipts).
 *
 * Empty strings render as a visible "<TODO:…>" placeholder in the UI until
 * filled in. Do not deploy with placeholders in production.
 */
export const legalEntity = {
  name:         "",
  registration: "",
  address:      "",
  phone:        "",
} as const;

/**
 * Safe display accessor — returns the value or a visible TODO placeholder so
 * missing legal info is immediately obvious in the UI (rather than rendering
 * blank or crashing).
 */
export function legal(field: keyof typeof legalEntity): string {
  const value = legalEntity[field];
  return value || `<TODO: legal entity ${field}>`;
}
